import { IPagination, IPaginationDTO } from './pagination.model';

export enum StockBalancesEndpoints {
  STOCK_BALANCES = '/stock-balances',
  STOCK_BALANCES_REGIONS = '/stock-balances/regions',
  STOCK_BALANCES_CATEGORIES = '/stock-balances/categories',
}

export interface IStockBalanceProduct {
  id: string;
  name: string;
  sku: string;
  external_id: string;
  active: boolean;
  unit_code?: string | null;
  category?: string | null;
}

export interface IStockBalanceRegion {
  id: string;
  name: string;
}

export interface IStockBalanceStore {
  id: string;
  title: string;
  slug: string;
}

export interface IStockBalancePartner {
  id: string;
  name: string;
}

export interface IStockBalance {
  id: string;
  quantity: number;
  available: boolean;
  price: number;
  discount_price: number | null;
  line_total: number;
  product: IStockBalanceProduct;
  region: IStockBalanceRegion;
  store?: IStockBalanceStore;
  partner?: IStockBalancePartner;
}

export interface IStockBalancesListMeta extends IPagination {
  stocks_total?: number;
  stock_value_total?: number;
}

export interface IGetStockBalancesDTO extends Partial<IPaginationDTO> {
  region_id?: string;
  sku?: string;
  name?: string;
  external_id?: string;
  search?: string;
  category_ids?: string[];
  active?: boolean;
  available?: boolean;
  quantity_min?: number;
  quantity_max?: number;
  price_min?: number;
  price_max?: number;
  discount_price_min?: number;
  discount_price_max?: number;
  store_ids?: string[];
  partner_ids?: string[];
}

export interface IGetStockBalancesResponse {
  data: IStockBalance[];
  meta: IStockBalancesListMeta;
}

export interface IGetStockRegionsResponse {
  data: IStockBalanceRegion[];
}

export interface IStockBalanceCategory {
  id: string;
  name: string;
}

export interface IGetStockCategoriesResponse {
  data: IStockBalanceCategory[];
}
